import { Type } from '@sinclair/typebox';
// GET /api/sharepoint-sites — "which provisioned SharePoint sites belong to projects this user can
// see". Read entirely from our own ledger (ProjectSharePointSite + ProjectSharePointLibrary): the
// server makes no Graph call at all, so this route takes no delegated-token header. Site identity is
// the ledger's stored `siteId`, never re-derived from the `proj-<cuid>` URL alias, and each site
// carries its provisioned libraries so the client can address their drives by id (D15 — SharePoint
// derives a library's URL from its title only at creation, so a stored id is the only stable
// handle). No request body/query — the only input is the ordinary auth header.
//
// `libraries` is deliberately unfiltered: it lists every library the reconciler provisioned,
// including ones this caller cannot read (`CESG` for a GUEST). SharePoint stays the single
// enforcement point — the client probes each drive and hides the roots Graph refuses.
export const SharePointSiteLibrarySchema = Type.Object({
    // Matches SITE_LIBRARIES[].key. Kept a plain string (the DB column is a string); the client joins
    // it against SITE_LIBRARIES and drops anything the spec no longer declares.
    key: Type.String(),
    driveId: Type.String(),
});
export const SharePointSiteSchema = Type.Object({
    siteId: Type.String(),
    siteUrl: Type.String(),
    title: Type.String(),
    projectId: Type.String(),
    libraries: Type.Array(SharePointSiteLibrarySchema),
});
export const SharePointSitesResponseSchema = Type.Array(SharePointSiteSchema);
